import { ModuleWithProviders, NgModule } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { TransferHttpCacheModule } from '@nguniversal/common'
import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image'
import { DeviceDetectorModule } from 'ngx-device-detector'
import { DeferLoadModule } from '@trademe/ng-defer-load'
import { CommonModule } from '@angular/common'
import { ImageComponent } from './components/sharedComponent/image.component'
import { SwiperModule } from 'ngx-swiper-wrapper'
import { BlogDesktopComponent } from './components/sharedComponent/blog-component/blog-desktop/blog-desktop.component'
import { AppearModule } from '@flowaccount/landing'
import { FaqDesktopComponent } from './components/sharedComponent/faq-component/faq-desktop/faq-desktop.component'
import { DownloadpdfDesktopComponent } from './components/sharedComponent/downloadpdf-component/downloadpdf-desktop/downloadpdf-desktop.component'
import { CtaDesktopComponent } from './components/sharedComponent/cta-component/cta-desktop/cta-desktop.component'
import { TechBlogComponent } from './components/sharedComponent/tech-blog/tech-blog.component'
import { FaqAccordionComponent } from './components/sharedComponent/faq-accordion/faq-accordion.component'
import { BlogSwiperComponent } from './components/sharedComponent/blog-swiper/blog-swiper.component'
import { ConnectionAddOnPackageComponent } from './components/sharedComponent/connection-add-on-package/connection-add-on-package.component'
import { InviteToUseSectionComponent } from './components/sharedComponent/invite-to-use-section/invite-to-use-section.component'
import { TaxCalendarSwiperComponent } from './components/sharedComponent/tax-calendar-swiper/tax-calendar-swiper.component'
import { ReviewSetionComponent } from './components/sharedComponent/review-setion/review-setion.component'
import { BlogSwiperSquidexComponent } from './components/sharedComponent/blog-swiper-squidex/blog-swiper-squidex.component'
import { FaqAccordionSquidexComponent } from './components/sharedComponent/faq-accordion-squidex/faq-accordion-squidex.component'
import { PromotionalBannerSquidexComponent } from './components/sharedComponent/promotional-banner-squidex/promotional-banner-squidex.component'
import { StarterKitSharedComponent } from './components/sharedComponent/starter-kit-shared/starter-kit-shared.component'
import { ReactiveFormsModule } from '@angular/forms'
import { ContentCallToActionSquidexComponent } from './components/sharedComponent/content-call-to-action-squidex/content-call-to-action-squidex.component'
import { TranslateModule } from '@ngx-translate/core'
import { ContentCallToActionPrivilegeComponent } from './components/sharedComponent/content-call-to-action-privilege/content-call-to-action-privilege.component'
import { TaxInvoiceBannerSharedComponent } from './components/sharedComponent/tax-invoice-banner-shared/tax-invoice-banner-shared.component'

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}

@NgModule({
  declarations: [
    ImageComponent,
    BlogDesktopComponent,
    FaqDesktopComponent,
    DownloadpdfDesktopComponent,
    CtaDesktopComponent,
    TechBlogComponent,
    FaqAccordionComponent,
    BlogSwiperComponent,
    ConnectionAddOnPackageComponent,
    InviteToUseSectionComponent,
    TaxCalendarSwiperComponent,
    ReviewSetionComponent,
    BlogSwiperSquidexComponent,
    FaqAccordionSquidexComponent,
    PromotionalBannerSquidexComponent,
    StarterKitSharedComponent,
    ContentCallToActionSquidexComponent,
    ContentCallToActionPrivilegeComponent,
    TaxInvoiceBannerSharedComponent,
  ],
  imports: [
    CommonModule,
    AppearModule,
    // AlertModule.forRoot(),
    LazyLoadImageModule.forRoot({
      preset: intersectionObserverPreset, // <-- tell LazyLoadImage that you want to use IntersectionObserver
    }),
    TransferHttpCacheModule,
    DeviceDetectorModule.forRoot(),
    DeferLoadModule,
    SwiperModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    DeferLoadModule,
    SwiperModule,
    TransferHttpCacheModule,
    LazyLoadImageModule,
    ImageComponent,
    BlogDesktopComponent,
    FaqDesktopComponent,
    DownloadpdfDesktopComponent,
    CtaDesktopComponent,
    TechBlogComponent,
    FaqAccordionComponent,
    BlogSwiperComponent,
    ConnectionAddOnPackageComponent,
    InviteToUseSectionComponent,
    TaxCalendarSwiperComponent,
    ReviewSetionComponent,
    BlogSwiperSquidexComponent,
    FaqAccordionSquidexComponent,
    PromotionalBannerSquidexComponent,
    StarterKitSharedComponent,
    ContentCallToActionSquidexComponent,
    ContentCallToActionPrivilegeComponent,
    TaxInvoiceBannerSharedComponent,
  ],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [],
    }
  }
}
export interface IErrorResponse {
  errorMessage: string
}
